export class RegistriesFactory {
  createAll() {
    return {};
  }
}
